/* Vans.hu – Vans.com stílusú szűrő (oldalsáv, méretrendszer-váltó, állapotmegőrzés) */
(function () {
  'use strict';
  var SIZE_MAP = {"16":{"us":"1","uk":"0.5","cm":"3.3"},"17":{"us":"2","uk":"1.5","cm":"9"},"18":{"us":"3","uk":"2.5","cm":"10"},"19":{"us":"4","uk":"3.5","cm":"10.5"},"20":{"us":"4.5","uk":"4","cm":"11"},"21":{"us":"5","uk":"4.5","cm":"11.5"},"22":{"us":"6","uk":"5.5","cm":"12"},"24":{"us":"7.5","uk":"7","cm":"13.5"},"25":{"us":"8.5","uk":"8","cm":"14.5"},"26":{"us":"9.5","uk":"9","cm":"15.5"},"27":{"us":"10.5","uk":"10","cm":"15.5"},"28":{"us":"11.5","uk":"11","cm":"16.5"},"29":{"us":"12","uk":"11.5","cm":"17"},"30":{"us":"12.5","uk":"12","cm":"17.5"},"31":{"us":"13.5","uk":"13","cm":"18.5"},"32":{"us":"1.5","uk":"1","cm":"19.5"},"33":{"us":"2.5","uk":"2","cm":"20.5"},"34":{"us":"3","uk":"2.5","cm":"21"},"35":{"us":"4","uk":"3","cm":"22"},"36":{"us":"4.5","uk":"3.5","cm":"22.5"},"37":{"us":"5.5","uk":"4.5","cm":"23.5"},"38":{"us":"6","uk":"5","cm":"24"},"39":{"us":"7","uk":"6","cm":"25"},"40":{"us":"7.5","uk":"6.5","cm":"25.5"},"41":{"us":"8.5","uk":"7.5","cm":"26.5"},"42":{"us":"9","uk":"8","cm":"27"},"43":{"us":"10","uk":"9","cm":"28"},"44":{"us":"10.5","uk":"9.5","cm":"28.5"},"45":{"us":"11.5","uk":"10.5","cm":"29.5"},"46":{"us":"12","uk":"11","cm":"30"},"47":{"us":"13","uk":"12","cm":"31"},"48":{"us":"14","uk":"13","cm":"32"},"49":{"us":"15","uk":"14","cm":"33"},"50":{"us":"16","uk":"15","cm":"34"},"51":{"us":"17","uk":"16","cm":"35"},"42.5":{"us":"9.5","uk":"8.5","cm":"27.5"},"44.5":{"us":"11","uk":"10","cm":"29"},"38.5":{"us":"6.5","uk":"5.5","cm":"24.5"},"40.5":{"us":"8","uk":"7","cm":"26"},"36.5":{"us":"5","uk":"4","cm":"23"},"27.5":{"us":"11","uk":"10.5","cm":"16"},"30.5":{"us":"13","uk":"12.5","cm":"18"},"31.5":{"us":"1","uk":"13.5","cm":"19"},"32.5":{"us":"2","uk":"1.5","cm":"20"},"34.5":{"us":"3.5","uk":"2.5","cm":"21.5"},"22.5":{"us":"6.5","uk":"6","cm":"12.5"},"23.5":{"us":"7","uk":"6.5","cm":"13"},"26.5":{"us":"10","uk":"9.5","cm":"16"},"21.5":{"us":"5.5","uk":"5","cm":"12"},"18.5":{"us":"3.5","uk":"3","cm":"10.5"},"25.5":{"us":"9","uk":"8.5","cm":"15"},"24.5":{"us":"8","uk":"7.5","cm":"14"},"17.5":{"us":"2.5","uk":"2","cm":"9.5"},"28-29":{"us":"11","uk":"11","cm":"17.4"},"29-30":{"us":"12","uk":"12","cm":"18.3"},"30-31":{"us":"13","uk":"13","cm":"19.1"},"32-33":{"us":"1","uk":"1","cm":"20"},"33-34":{"us":"2","uk":"2","cm":"20.8"},"34-35":{"us":"3","uk":"3","cm":"21.7"},"36-37":{"us":"4","uk":"4","cm":"22.5"},"37-38":{"us":"5","uk":"5","cm":"23.3"},"38-39":{"us":"6","uk":"6","cm":"24.2"}};
  var DESKTOP = 990;
  var ORDER = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL', '6XL'];
  var html = document.documentElement;

  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }
  function isDesktop() { return window.innerWidth >= DESKTOP; }
  /* Nyitott állapot csak ugyanazon a kollekción marad meg; új kollekción alapból csukva */
  function wasOpen() { return ss('vf-open') === location.pathname; }

  /* ---------- Oldalsáv ki/be ---------- */
  function syncToggle() {
    var open = html.classList.contains('vf-open');
    document.querySelectorAll('.vf-toggle').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  if (wasOpen() && isDesktop()) html.classList.add('vf-open');

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.vf-toggle');
    if (t) {
      e.preventDefault();
      if (isDesktop()) {
        var open = !html.classList.contains('vf-open');
        html.classList.toggle('vf-open', open);
        ss('vf-open', open ? location.pathname : '0');
        syncToggle();
        sizePane();
      } else {
        var dlg = document.getElementById('filters-drawer');
        if (dlg && typeof dlg.showDialog === 'function') dlg.showDialog();
      }
      return;
    }

    var sysBtn = e.target.closest && e.target.closest('.vf-sizesys__btn');
    if (sysBtn) {
      e.preventDefault();
      ss('vf-size-sys', sysBtn.getAttribute('data-sys'));
      applySizeSystem();
      return;
    }

    var reset = e.target.closest && e.target.closest('.vf-price__reset');
    if (reset) {
      e.preventDefault();
      var comp = reset.closest('price-facet-component');
      if (!comp) return;
      comp.querySelectorAll('.vf-price__input').forEach(function (i) { i.value = ''; });
      var apply = comp.querySelector('.vf-price__apply');
      if (apply) apply.click();
    }
  });

  /* ---------- Ár csúszka ---------- */
  function fmtFt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft'; }
  function syncRange(box) {
    var lo = box.querySelector('.vf-range__lo'), hi = box.querySelector('.vf-range__hi');
    if (!lo || !hi) return;
    var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
    var a = +lo.value, b = +hi.value;
    var span = Math.max(1, max - min);
    var fill = box.querySelector('.vf-range__fill');
    if (fill) { fill.style.left = ((a - min) / span * 100) + '%'; fill.style.right = ((max - b) / span * 100) + '%'; }
    var lv = box.querySelector('.vf-range__lo-val'), hv = box.querySelector('.vf-range__hi-val');
    if (lv) lv.textContent = fmtFt(a);
    if (hv) hv.textContent = fmtFt(b);
    lo.style.zIndex = (a > min + span * 0.9) ? 3 : 2;
  }
  var boundsCache = {};
  function boundsUrl(sort) {
    var u = new URL(location.href);
    var q = u.searchParams;
    ['filter.v.price.gte', 'filter.v.price.lte', 'page', 'sort_by', 'view', 'section_id'].forEach(function (k) { q.delete(k); });
    q.set('sort_by', sort);
    q.set('view', 'vfprice');
    return u.pathname + '?' + q.toString();
  }
  function loadBounds() {
    if (location.pathname.indexOf('/collections/') !== 0) return Promise.resolve(null);
    var key = boundsUrl('x');
    if (boundsCache[key]) return boundsCache[key];
    var get = function (sort) {
      return fetch(boundsUrl(sort), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var m = t.trim().match(/^(\d+)\|(\d+)$/);
        return m ? m : null;
      }).catch(function () { return null; });
    };
    boundsCache[key] = Promise.all([get('price-ascending'), get('price-descending')]).then(function (r) {
      if (!r[0] || !r[1]) return null;
      return { min: Math.floor(+r[0][1] / 100), max: Math.ceil(+r[1][2] / 100) };
    });
    return boundsCache[key];
  }
  function applyBounds(box, b) {
    if (!b || b.max <= b.min) return;
    var lo = box.querySelector('.vf-range__lo'), hi = box.querySelector('.vf-range__hi');
    var comp = box.closest('price-facet-component');
    var inputs = comp ? comp.querySelectorAll('.vf-price__input') : [];
    var curLo = inputs[0] && inputs[0].value ? +inputs[0].value : b.min;
    var curHi = inputs[1] && inputs[1].value ? +inputs[1].value : b.max;
    box.setAttribute('data-min', b.min);
    box.setAttribute('data-max', b.max);
    [lo, hi].forEach(function (el) { el.min = b.min; el.max = b.max; });
    lo.value = Math.max(b.min, Math.min(curLo, b.max));
    hi.value = Math.min(b.max, Math.max(curHi, b.min));
    syncRange(box);
  }
  function initRanges(root) {
    var boxes = (root || document).querySelectorAll('.vf-range');
    boxes.forEach(syncRange);
    if (!boxes.length) return;
    loadBounds().then(function (b) {
      document.querySelectorAll('.vf-range').forEach(function (box) { applyBounds(box, b); });
    });
  }
  document.addEventListener('input', function (e) {
    var r = e.target.closest && e.target.closest('.vf-range__input');
    if (!r) return;
    var box = r.closest('.vf-range');
    var lo = box.querySelector('.vf-range__lo'), hi = box.querySelector('.vf-range__hi');
    if (+lo.value > +hi.value) { if (r === lo) lo.value = hi.value; else hi.value = lo.value; }
    syncRange(box);
  }, true);
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('.vf-range__input');
    if (!r) return;
    e.stopPropagation();
    var box = r.closest('.vf-range');
    var comp = box.closest('price-facet-component');
    var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
    var lo = +box.querySelector('.vf-range__lo').value, hi = +box.querySelector('.vf-range__hi').value;
    var inputs = comp.querySelectorAll('.vf-price__input');
    if (inputs[0]) inputs[0].value = lo > min ? String(lo) : '';
    if (inputs[1]) inputs[1].value = hi < max ? String(hi) : '';
    var apply = comp.querySelector('.vf-price__apply');
    if (apply) apply.click();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest && e.target.closest('.vf-price__input');
    if (!inp) return;
    e.preventDefault();
    var apply = inp.closest('price-facet-component') && inp.closest('price-facet-component').querySelector('.vf-price__apply');
    if (apply) apply.click();
  });

  window.addEventListener('resize', function () {
    if (!isDesktop()) html.classList.remove('vf-open');
    else if (wasOpen()) html.classList.add('vf-open');
    syncToggle();
  });

  /* ---------- Oldalsáv magassága: mindig férjen be a képernyőbe ---------- */
  function stickyTop() {
    var h = document.querySelector('header-component, #header-component, .header-section, #header-group header');
    if (!h) return 0;
    var host = h;
    while (host && host !== document.body) {
      var p = getComputedStyle(host).position;
      if (p === 'sticky' || p === 'fixed') break;
      host = host.parentElement;
    }
    if (!host || host === document.body) return 0;
    var r = host.getBoundingClientRect();
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  var sizing = false;
  function sizePane() {
    var headTop = stickyTop();
    var bar = document.querySelector('.collection-wrapper > .facets-controls-wrapper, .facets-controls-wrapper');
    html.style.setProperty('--vf-bar-top', headTop + 'px');
    var barH = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    var pane = document.getElementById('vf-pane');
    if (!pane) return;
    if (!isDesktop() || !html.classList.contains('vf-open')) {
      pane.style.removeProperty('--vf-h');
      pane.style.removeProperty('--vf-top');
      return;
    }
    var top = headTop + barH;
    var rt = pane.getBoundingClientRect().top;
    var avail = window.innerHeight - Math.max(rt, top) - 8;
    pane.style.setProperty('--vf-top', top + 'px');
    pane.style.setProperty('--vf-h', Math.max(240, Math.round(avail)) + 'px');
  }
  var lastMove = 0;
  function loopSize() {
    sizePane();
    if (Date.now() - lastMove < 700) { sizing = true; requestAnimationFrame(loopSize); }
    else sizing = false;
  }
  function queueSize() {
    lastMove = Date.now();
    if (sizing) return;
    sizing = true;
    requestAnimationFrame(loopSize);
  }
  document.addEventListener('transitionend', queueSize, true);
  window.addEventListener('scroll', queueSize, { passive: true });
  window.addEventListener('resize', queueSize);

  /* ---------- Lenyitott csoportok megjegyzése ---------- */
  function getState() {
    try { return JSON.parse(ss('vf-groups2') || '{}') || {}; } catch (e) { return {}; }
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.hasAttribute('data-vf-key')) return;
    if (d.__vfApplying) return;
    var st = getState();
    st[d.getAttribute('data-vf-key')] = d.open ? 1 : 0;
    ss('vf-groups2', JSON.stringify(st));
  }, true);

  function applyGroups(root) {
    var st = getState();
    (root || document).querySelectorAll('details[data-vf-key]').forEach(function (d) {
      var k = d.getAttribute('data-vf-key');
      if (!(k in st)) return;
      var want = !!st[k];
      if (d.open !== want) {
        d.__vfApplying = true;
        d.open = want;
        setTimeout(function () { d.__vfApplying = false; }, 0);
      }
    });
  }

  /* ---------- Méretek: sorrend + EU/US/UK/CM ---------- */
  /* Csoportok: 0 = cipőméret, 1 = tartomány (zokni, pl. 42.5-47), 2 = betűs (XS, S, M…), 3 = W/L nadrágméret, 4 = minden más */
  function letterIdx(part) {
    part = part.replace(/\s+/g, '');
    var i = ORDER.indexOf(part);
    if (i > -1) return i;
    var m = part.match(/^(\d)XL$/);
    if (m) return ORDER.indexOf('XXXL') + (+m[1] - 3);
    return -1;
  }
  function sizeKey(label) {
    var l = (label || '').trim().toUpperCase().replace(',', '.');
    var m;
    if (/^\d+(\.\d+)?$/.test(l)) return [0, parseFloat(l), 0, l];
    if ((m = l.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/))) return [1, parseFloat(m[1]), parseFloat(m[2]), l];
    if ((m = l.match(/^([A-Z0-9]+)\s*[-\/]\s*([A-Z0-9]+)$/)) && letterIdx(m[1]) > -1 && letterIdx(m[2]) > -1) {
      return [2, letterIdx(m[1]) + 0.5, letterIdx(m[2]), l];
    }
    if (letterIdx(l) > -1) return [2, letterIdx(l), 0, l];
    if ((m = l.match(/^W\s*(\d+)(?:\s*L\s*(\d+))?$/))) return [3, +m[1], m[2] ? +m[2] : 0, l];
    var n = parseFloat(l);
    return [4, isNaN(n) ? 9999 : n, 0, l];
  }
  var sorting = false;
  function sortChips(root) {
    sorting = true;
    try { sortChipsInner(root); } finally { mo.takeRecords(); sorting = false; }
  }
  function sortDiscount(root) {
    (root || document).querySelectorAll('details[data-vf-key*="kedvezmeny"] .vf-list--checks').forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.children);
      var key = function (li) {
        var t = (li.textContent || '').trim();
        if (/^nincs/i.test(t)) return -1;
        var n = parseFloat(t);
        return isNaN(n) ? 999 : n;
      };
      var sorted = items.slice().sort(function (a, b) { return key(a) - key(b); });
      if (sorted.some(function (el, i) { return el !== items[i]; })) sorted.forEach(function (el) { ul.appendChild(el); });
    });
  }
  var COLOR_ORDER = ['Fekete', 'Fehér', 'Zöld', 'Kék', 'Szürke', 'Barna', 'Bézs', 'Rózsaszín', 'Lila', 'Piros', 'Checker', 'Bordó', 'Narancs', 'Sárga', 'Arany', 'Tarka', 'Ezüst'];
  function sortColors(root) {
    (root || document).querySelectorAll('details[data-vf-key*="szincsoport"] .vf-list--colors').forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.children);
      var key = function (li) {
        var n = li.querySelector('.vf-color__name');
        var i = COLOR_ORDER.indexOf(n ? n.textContent.trim() : '');
        return i < 0 ? 99 : i;
      };
      var sorted = items.slice().sort(function (a, b) { return key(a) - key(b); });
      if (sorted.some(function (el, i) { return el !== items[i]; })) sorted.forEach(function (el) { ul.appendChild(el); });
    });
  }
  function sortChipsInner(root) {
    sortDiscount(root);
    sortColors(root);
    (root || document).querySelectorAll('.vf-list--chips').forEach(function (ul) {
      var items = Array.prototype.filter.call(ul.children, function (el) { return !el.classList.contains('vf-chip-break'); });
      items.forEach(function (el) {
        var lab = el.querySelector('.vf-chip');
        var txt = lab ? (lab.getAttribute('data-eu') || '') : '';
        el.classList.toggle('vf-item--wide', txt.length > 5);
      });
      var keyed = items.map(function (el) {
        var lab = el.querySelector('.vf-chip');
        return { el: el, k: sizeKey(lab && lab.getAttribute('data-eu')) };
      });
      keyed.sort(function (a, b) {
        for (var i = 0; i < 3; i++) if (a.k[i] !== b.k[i]) return a.k[i] - b.k[i];
        return a.k[3].localeCompare(b.k[3]);
      });
      var want = [];
      var prev = null;
      keyed.forEach(function (x) {
        if (prev !== null && x.k[0] !== prev) want.push('break');
        want.push(x.el);
        prev = x.k[0];
      });
      var cur = Array.prototype.map.call(ul.children, function (el) { return el.classList.contains('vf-chip-break') ? 'break' : el; });
      var same = cur.length === want.length && cur.every(function (v, i) { return v === want[i]; });
      if (same) return;
      Array.prototype.slice.call(ul.querySelectorAll(':scope > .vf-chip-break')).forEach(function (el) { el.remove(); });
      want.forEach(function (v) {
        if (v === 'break') {
          var li = document.createElement('li');
          li.className = 'vf-chip-break';
          li.setAttribute('aria-hidden', 'true');
          ul.appendChild(li);
        } else {
          ul.appendChild(v);
        }
      });
    });
  }
  function applySizeSystem(root) {
    var sys = ss('vf-size-sys') || 'eu';
    (root || document).querySelectorAll('.vf-sizesys__btn').forEach(function (b) {
      var on = b.getAttribute('data-sys') === sys;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    (root || document).querySelectorAll('.vf-chip[data-eu]').forEach(function (lab) {
      var eu = lab.getAttribute('data-eu');
      var txt = eu;
      if (sys !== 'eu' && SIZE_MAP[eu] && SIZE_MAP[eu][sys]) txt = SIZE_MAP[eu][sys];
      if (lab.textContent !== txt) lab.textContent = txt;
      lab.setAttribute('title', sys === 'eu' ? 'EU ' + eu : sys.toUpperCase() + ' ' + txt + ' (EU ' + eu + ')');
    });
  }

  function refresh(root) {
    applyGroups(root);
    sortChips(root);
    applySizeSystem(root);
    initRanges(root);
    syncToggle();
    sizePane();
  }

  var queued = false;
  var mo = new MutationObserver(function (muts) {
    if (sorting) return;
    var relevant = muts.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('.vf-group, .vf-item, .vf-pane, .facets, accordion-custom, .vf-chip-break') || n.querySelector && n.querySelector('.vf-group'));
      }) || Array.prototype.some.call(m.removedNodes, function (n) {
        return n.nodeType === 1 && n.matches && n.matches('.vf-chip-break');
      });
    });
    if (!relevant || queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  });

  function init() {
    refresh();
    mo.observe(document.body, { childList: true, subtree: true });
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('accordion-custom').then(function () { setTimeout(refresh, 0); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
